<template>
  <div>
    <!-- Floating Button for small screens -->
    <button
      class="btn btn-secondary rounded-circle position-absolute top-0 start-0 m-3 d-lg-none"
      style="width: 48px; height: 48px; z-index: 1001"
      @click="toggleMobilePanel"
      ref="mobileToggleBtn"
      :aria-label="mobileOpen ? 'Close map tools' : 'Open map tools'"
      :aria-expanded="mobileOpen"
    >
      <i class="bi bi-tools" aria-hidden="true"></i>
    </button>

    <!-- Mobile compact panel -->
    <div
      v-if="mobileOpen"
      class="position-absolute top-0 start-0 m-3 bg-white rounded shadow-sm d-lg-none border"
      style="width: 240px; z-index: 1002"
      @click.stop
      ref="mobilePanel"
      role="dialog"
      aria-labelledby="mobile-tools-heading"
      aria-modal="true"
    >
      <div
        class="bg-light p-3 border-bottom d-flex justify-content-between align-items-center"
      >
        <h2 class="mb-0" id="h6 mobile-tools-heading">Map Tools</h2>
        <button
          type="button"
          class="btn-close"
          @click="toggleMobilePanel"
          aria-label="Close map tools panel"
        ></button>
      </div>
      <ToolsPanelContent
        :current-layer="currentLayer"
        :zoom-to-selected="mapSettings.zoomToSelected"
        id-suffix="-sm"
        @selectLayer="setExclusive"
        @toggleZoom="handleZoomToggle"
      />
    </div>

    <!-- Desktop/full panel -->
    <div
      class="position-absolute top-0 start-0 m-3 bg-white rounded shadow-sm d-none d-lg-block border"
      style="width: 200px; z-index: 1000"
      role="region"
      aria-labelledby="desktop-tools-heading"
    >
      <div class="bg-light p-3 border-bottom">
        <h5 class="mb-0" id="desktop-tools-heading">Map Tools</h5>
      </div>
      <ToolsPanelContent
        :current-layer="currentLayer"
        :zoom-to-selected="mapSettings.zoomToSelected"
        @selectLayer="setExclusive"
        @toggleZoom="handleZoomToggle"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ToolsPanelContent from "./ToolsPanelContent.vue";

export default {
  name: "MapToolsPanel",
  components: { ToolsPanelContent },
  data() {
    return {
      mobileOpen: false
    };
  },
  mounted() {
    document.addEventListener("click", this.handleGlobalClick, true);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleGlobalClick, true);
  },
  computed: {
    ...mapGetters({
      activeLayers: "activeLayers",
      mapSettings: "mapSettings",
      selectedItem: "selectedItem"
    }),
    currentLayer() {
      if (this.activeLayers.cultural) return "cultural";
      if (this.activeLayers.migration_wave_1) return "migration_wave_1";
      if (this.activeLayers.migration_wave_2) return "migration_wave_2";
      return "none"; // fallback when no layers are active
    }
  },
  methods: {
    ...mapActions({
      toggleZoomToSelectedAction: "toggleZoomToSelected",
      setActiveLayerExclusiveAction: "setActiveLayerExclusive"
    }),
    toggleMobilePanel() {
      this.mobileOpen = !this.mobileOpen;
    },
    handleGlobalClick(event) {
      if (!this.mobileOpen) return;
      const panel = this.$refs.mobilePanel;
      const button = this.$refs.mobileToggleBtn;
      if (!panel || !button) {
        this.mobileOpen = false;
        return;
      }
      const target = event.target;
      const clickedInsidePanel = panel.contains(target);
      const clickedButton = button.contains(target);
      if (!clickedInsidePanel && !clickedButton) {
        this.mobileOpen = false;
      }
    },
    setExclusive(layer) {
      this.setActiveLayerExclusiveAction(layer);
    },
    handleZoomToggle(enabled) {
      this.toggleZoomToSelectedAction(enabled);

      // If toggling ON and there's a currently selected item, trigger zoom immediately
      if (enabled && this.selectedItem) {
        this.$emit("zoomToCurrentSelection");
      }
    }
  }
};
</script>

<style scoped>
/* All styling is now handled by Bootstrap utility classes */
</style>
